import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const CommonModal = ({ isOpen, toggle, title, children, size = "lg" }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
};

export default CommonModal;